export type IconDomainHopParams = {
  jwt?: string | null
  refreshToken?: string | null
  saveJwt: (jwt: string) => void | Promise<void>
  refreshLegacySession: (refreshToken: string) => Promise<void>
  establishLegacyCookie: () => Promise<void>
}

/**
 * After portal.voicefriend.net → messaging.goicon.com, VFAuth cannot be copied.
 * Persist the JWT, optionally rotate via refresh_token, then always mint VFAuth
 * on the current host so legacy iframes can authenticate.
 */
export async function completeIconDomainHop({
  jwt,
  refreshToken,
  saveJwt,
  refreshLegacySession,
  establishLegacyCookie,
}: IconDomainHopParams): Promise<boolean> {
  if (!jwt) {
    return false;
  }

  await saveJwt(jwt);

  if (refreshToken) {
    await refreshLegacySession(refreshToken);
  }

  await establishLegacyCookie();
  return true;
}
